import { Button } from 'antd';
import styled from 'styled-components';

export const FullScreenContainer = styled.div`
  height: 100vh;
  max-height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  
  @media (max-width: 1024px) {
    height: auto;
    max-height: none;
    min-height: 100vh;
    overflow-y: auto;
  }
`;

export const StepContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  max-width: 1600px;
  margin: 0 auto;
  width: 100%;
  min-height: 0;
  overflow: hidden;
  
  @media (max-width: 768px) {
    padding: 16px;
    overflow-y: auto;
  }
  
  @media (max-width: 480px) {
    padding: 12px;
  }
`;

export const SplitLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 24px;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  
  > * {
    min-height: 0;
    overflow: hidden;
  }
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    gap: 16px;
    overflow-y: auto;
  }
  
  @media (max-width: 480px) {
    gap: 12px;
  }
`;

export const TimeSelectionPanel = styled.div`
  background: white;
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: 100%;
  height: 100%;
  overflow: hidden;
  
  @media (max-width: 1024px) {
    order: 2;
    max-height: 400px;
    height: auto;
    min-height: auto;
  }
  
  @media (max-width: 480px) {
    border-radius: 8px;
    max-height: 350px;
  }
`;

export const TimeSelectionHeader = styled.div`
  padding: 14px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
  flex-shrink: 0;
  
  @media (max-width: 480px) {
    padding: 12px;
  }
`;

export const TimeSelectionContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  min-height: 0;
  max-height: 100%;
  
  @media (max-width: 1024px) {
    max-height: none;
    min-height: auto;
  }
  
  @media (max-width: 480px) {
    padding: 12px;
  }
`;

export const StepHeader = styled.div`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 768px) {
    padding: 0 0 16px 0;
    margin-bottom: 16px;
  }
  
  @media (max-width: 480px) {
    padding: 0 0 12px 0;
    margin-bottom: 12px;
  }
  
  h1 {
    @media (max-width: 768px) {
      font-size: 24px !important;
    }
    
    @media (max-width: 480px) {
      font-size: 20px !important;
      margin-bottom: 8px !important;
    }
  }
  
  .ant-tag {
    @media (max-width: 480px) {
      font-size: 12px !important;
      padding: 4px 8px !important;
    }
  }
  
  .ant-typography {
    @media (max-width: 480px) {
      font-size: 12px !important;
    }
  }
`;

export const EventInfoCard = styled.div`
  background: linear-gradient(135deg, ${props => props.color || '#1890ff'}15 0%, ${props => props.color || '#1890ff'}08 100%);
  border: 1px solid ${props => props.color || '#1890ff'}30;
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  
  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
  }
  
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const EventIconWrapper = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: ${props => props.color || '#1890ff'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 28px;
  flex-shrink: 0;
  box-shadow: 0 4px 12px ${props => props.color || '#1890ff'}40;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

export const EventDetails = styled.div`
  flex: 1;
  
  h3 {
    margin: 0 0 8px 0;
    font-size: 20px;
    font-weight: 600;
    color: #262626;
    
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
`;

export const EventMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  
  @media (max-width: 480px) {
    gap: 12px;
  }
`;

export const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #666;
  
  .anticon {
    font-size: 16px;
    color: ${props => props.color || '#999'};
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const ProgressSteps = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 32px;
  
  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
`;

export const ProgressStep = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:not(:last-child)::after {
    content: '';
    width: 40px;
    height: 2px;
    background: ${props => {
      if (props.completed && props.nextCompleted) return '#000000';
      if (props.completed && props.nextActive) return '#1890ff';
      return '#e8e8e8';
    }};
    margin-left: 8px;
    
    @media (max-width: 480px) {
      width: 20px;
    }
  }
`;

export const StepCircle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${props => props.active ? '#1890ff' : props.completed ? '#000000' : '#f0f0f0'};
  color: ${props => props.active || props.completed ? 'white' : '#999'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
  transition: all 0.3s ease;
  
  @media (max-width: 480px) {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
`;

export const StepLabel = styled.span`
  font-size: 14px;
  color: ${props => props.active ? '#262626' : '#999'};
  font-weight: ${props => props.active ? '600' : '400'};
  
  @media (max-width: 768px) {
    display: none;
  }
`;

export const CalendarContainer = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  background: white;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  margin: 0 auto;
  width: 100%;
  max-width: 100%;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  
  @media (max-width: 1024px) {
    height: auto;
    min-height: auto;
  }
  
  @media (max-width: 480px) {
    border-radius: 8px;
  }
`;

export const CalendarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 28px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  
  @media (max-width: 768px) {
    padding: 16px 20px;
  }
  
  @media (max-width: 480px) {
    padding: 12px 16px;
  }
`;

export const CalendarGrid = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;

  .calendar-weekdays {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    background: #f8f9fa;
    border-bottom: 1px solid #e8e8e8;
    flex-shrink: 0;
    
    .weekday {
      padding: 16px;
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      color: #666;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      
      @media (max-width: 768px) {
        padding: 12px 8px;
        font-size: 12px;
        letter-spacing: 0.3px;
      }
      
      @media (max-width: 480px) {
        padding: 8px 4px;
        font-size: 10px;
      }
    }
  }
  
  .calendar-days {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-auto-rows: 1fr;
    flex: 1;
    min-height: 0;
    
    .calendar-day {
      padding: 12px;
      border-right: 1px solid #f0f0f0;
      border-bottom: 1px solid #f0f0f0;
      cursor: pointer;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      transition: all 0.15s ease;
      background: white;
      
      @media (max-width: 1200px) {
        min-height: 70px;
        padding: 10px;
      }
      
      @media (max-width: 768px) {
        min-height: 60px;
        padding: 8px;
      }
      
      @media (max-width: 480px) {
        min-height: 45px;
        padding: 6px;
      }
      
      &:nth-child(7n) {
        border-right: none;
      }
      
      &:hover:not(.disabled):not(.other-month) {
        background: #f0f8ff;
        transform: scale(1.02);
        z-index: 1;
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);
        
        .day-number {
          color: #262626;
        }
      }
      
      &.selected {
        background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
        color: white;
        font-weight: 600;
        border-color: #1890ff;
        box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
        z-index: 2;
        
        .day-number {
          color: white;
        }
        
        &:hover {
          background: linear-gradient(135deg, #0050b3 0%, #1890ff 100%);
          transform: scale(1.05);
          
          .day-number {
            color: white;
          }
        }
      }
      
      &.today {
        background: #f0f8ff;
        font-weight: 600;
        border: 2px solid #1890ff;
        
        &.selected {
          background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
          color: white;
          border-color: #1890ff;
        }
      }
      
      &.blocked {
        background: #fff1f0;
        color: #cf1322;
        cursor: not-allowed;
        border-color: #ffccc7;
        
        .day-number {
          color: #cf1322;
        }
        
        &:hover {
          background: #fff1f0;
          transform: none;
          box-shadow: none;
        }
      }
      
      &.disabled {
        color: #d9d9d9;
        cursor: not-allowed;
        background: #fafafa;
        
        &:hover {
          background: #fafafa;
          transform: none;
          box-shadow: none;
        }
      }
      
      &.other-month {
        color: #bfbfbf;
        background: #fafafa;
        
        &:hover {
          background: #fafafa;
          transform: none;
          box-shadow: none;
        }
      }
      
      .day-number {
        font-size: 20px;
        line-height: 1;
        font-weight: 500;
        
        @media (max-width: 1200px) {
          font-size: 18px;
        }
        
        @media (max-width: 768px) {
          font-size: 16px;
        }
        
        @media (max-width: 480px) {
          font-size: 14px;
        }
      }
    }
  }
`;

export const NavigationButton = styled(Button)`
  border: 1px solid #d9d9d9;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  min-height: 36px !important;
  max-width: 36px !important;
  max-height: 36px !important;
  border-radius: 50% !important;
  font-size: 14px;
  background: white;
  padding: 0 !important;
  flex-shrink: 0;
  
  &:hover {
    background: #f5f5f5;
    border-color: #40a9ff;
    color: #40a9ff;
  }
  
  &:focus {
    background: #f5f5f5;
    border-color: #40a9ff;
    color: #40a9ff;
  }
`;

export const MonthYearTitle = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: #262626;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 20px;
  }
  
  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const BackLink = styled.span`
  color: #1890ff;
  cursor: pointer;
  font-size: 15px;
  text-decoration: underline;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  
  &:hover {
    color: #40a9ff;
    text-decoration: underline;
  }
  
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
